module.exports = __webpack_public_path__ + "img/mail_open.684b4c48.png";